export default __webpack_public_path__ + "static/media/talles_remeras.7c6acc21.jpeg";